import React, { useState } from 'react';
import { PickAnimated, SpringValues, useSpring } from 'react-spring';

interface IUseIconButtonHoverAnimationOptions {
  isActive?: boolean;
  startingOpacity?: number;
  scaleAmount?: number;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  /**
   * If this is provided, it will resize the element width, height, and background-size,
   * rather than just using css transform scale.
   */
  sizes?: {
    starting: string;
    ending: string;
  };
}

export function useIconButtonHoverAnimation({
  isActive = false,
  startingOpacity = 1,
  scaleAmount = 1.5,
  onMouseEnter: onEnter,
  onMouseLeave: onLeave,
  sizes,
}: IUseIconButtonHoverAnimationOptions) {
  const [hovered, setHovered] = useState(false);

  const grow = hovered && !isActive;
  const onMouseEnter = (e: React.MouseEvent) => {
    setHovered(true);
    onEnter?.(e);
  };
  const onMouseLeave = (e: React.MouseEvent) => {
    setHovered(false);
    onLeave?.(e);
  };

  // TODO if we want it to be more like Mac Dock, we need to know about neighbor's state as well.
  const size = sizes ? (grow ? sizes.ending : sizes.starting) : undefined;
  const iconStyle: SpringValues<PickAnimated<{}>> = useSpring({
    opacity: grow || isActive ? 1 : startingOpacity,
    transform: sizes ? undefined : grow ? `scale(${scaleAmount})` : `scale(1)`,
    width: size,
    height: size,
    backgroundSize: size,
    /** https://react-spring.io/common/configs#configs */
    config: {
      tension: 340,
    },
  });

  return { iconStyle, onMouseEnter, onMouseLeave, hovered };
}
